// extracted by mini-css-extract-plugin
module.exports = {"webpage":"WebPage_webpage__at4CC"};